import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getPermissionByName, hasReportPermission, isAuthenticated } from './customMethods';

/**
 * ProtectedRoute component that checks both authentication and permissions
 * Supports both master-level permissions and report-level permissions
 */
const ProtectedRoute = ({ component: Component, permissionName, reportType, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        // Check if user is authenticated
        if (!isAuthenticated()) {
          return <Redirect to="/login" />;
        }

        // If reportType is specified, check report-level permission
        if (reportType) {
          // Check master reports permission first
          if (!getPermissionByName('reports')) {
            return (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2 style={{ color: '#dc3545' }}>Access Denied</h2>
                <p>You do not have permission to access reports.</p>
              </div>
            );
          }
          
          // Then check specific report permission
          if (!hasReportPermission(reportType)) {
            return (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2 style={{ color: '#dc3545' }}>Access Denied</h2>
                <p>You do not have permission to access this report.</p>
              </div>
            );
          }
        }
        // Otherwise check master-level permission
        else if (permissionName) {
          if (!getPermissionByName(permissionName)) {
            return (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2 style={{ color: '#dc3545' }}>Access Denied</h2>
                <p>You do not have permission to access this page.</p>
              </div>
            );
          }
        }

        // User has permission, render the component
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
